import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import BodyFont from '../../../Theme/Fonts/Body'
import { TestID } from '../../../utils/PropTypesDefinitions'

type SnackBarProps = {
    text: string
    onPress: () => void
    backgroundColor?: 'onyx' | 'ORANGE' | 'keshi-3'
} & TestID

const SnackBarWithLink: FunctionComponent<SnackBarProps> = ({
    text,
    onPress,
    backgroundColor = 'ORANGE',
    testID,
}): ReactElement => (
    <Touchable onPress={onPress} activeOpacity={0.8} testID={testID}>
        <Grid
            noExpand
            horizontal
            centerVertical
            backgroundColor={backgroundColor}
            paddingX={5}
            paddingY={3}
            borderRadius={3}
        >
            <Grid marginRight={5}>
                <BodyFont color="WHITE">{text}</BodyFont>
            </Grid>
            <FontelloIcon name="scroll-right" fontSize={15} color="WHITE" textAlign="center" />
        </Grid>
    </Touchable>
)

export default SnackBarWithLink
